module.exports = __webpack_public_path__ + "static/img/govcard_10.dd46a8d6.svg";